// File: src/English/EnglishTool/advancedVerbQuestions.js
import { shuffleArray } from "./shuffleArray.js";

/* ====== VOICE, MOOD, TENSE, VERBALS, ETC. ====== */

// Passive/Active Voice
export function buildVoiceMC() {
  return {
    questionType: "MC",
    question: "Which sentence is in passive voice?",
    correctAnswer: "The cake was eaten by the children.",
    options: shuffleArray([
      "The cake was eaten by the children.",
      "The children eat the cake.",
      "The children will eat the cake.",
      "Eat the cake."
    ])
  };
}

// Subjunctive Mood
export function buildSubjunctiveMoodMC() {
  return {
    questionType: "MC",
    question: "Which sentence is in the subjunctive mood?",
    correctAnswer: "If I were a bird, I would fly.",
    options: shuffleArray([
      "If I were a bird, I would fly.",
      "Birds fly in the sky.",
      "I was a bird last night.",
      "She will fly if she can."
    ])
  };
}

// Conditional Mood
export function buildConditionalMoodMC() {
  return {
    questionType: "MC",
    question: "Which sentence uses the conditional mood?",
    correctAnswer: "If it rains, we will stay inside.",
    options: shuffleArray([
      "If it rains, we will stay inside.",
      "It is raining.",
      "We stayed inside.",
      "Stay inside if it rains."
    ])
  };
}

// Tense Recognition
export function buildVerbTenseMC() {
  return {
    questionType: "MC",
    question: "What is the tense of the verb in: 'She had finished her work'?",
    correctAnswer: "Past perfect",
    options: shuffleArray([
      "Past perfect",
      "Simple past",
      "Present perfect",
      "Future"
    ])
  };
}

// Gerund/Infinitive Distinction
export function buildVerbalsMC() {
  return {
    questionType: "MC",
    question: "Which word is a gerund in this sentence? 'Swimming is good exercise.'",
    correctAnswer: "Swimming",
    options: shuffleArray([
      "Swimming",
      "exercise",
      "is",
      "good"
    ])
  };
}

export function buildInfinitiveMC() {
  return {
    questionType: "MC",
    question: "Which is the infinitive phrase in: 'He likes to run in the morning.'?",
    correctAnswer: "to run",
    options: shuffleArray([
      "to run",
      "likes",
      "in the morning",
      "He"
    ])
  };
}

// Identify all verbs
export function buildVerbIdentify() {
  return {
    questionType: "IDENTIFY",
    question: "Type all verbs in this sentence, separated by commas: 'She was reading and taking notes.'",
    correctAnswers: ["was", "reading", "taking"]
  };
}

export function buildParticipleMC() {
  return {
    questionType: "MC",
    question: "Which word in this sentence is a present participle? 'The running water is cold.'",
    correctAnswer: "running",
    options: shuffleArray([
      "running",
      "water",
      "is",
      "cold"
    ])
  };
}

// FITB: Write a sentence in passive voice using "discover"
export function buildPassiveFITB() {
  return {
    questionType: "FITB",
    question: "Write a sentence in passive voice using the verb 'discover'.",
    correctAnswer: "discover",
    checkType: "keyword-in-sentence",
    requiredWord: "discover"
  };
}

/* ====== POOL EXPORT ====== */
export const allAdvancedVerbQuestions = [
  buildVoiceMC,
  buildSubjunctiveMoodMC,
  buildConditionalMoodMC,
  buildVerbTenseMC,
  buildVerbalsMC,
  buildInfinitiveMC,
  buildVerbIdentify,
  buildParticipleMC,
  buildPassiveFITB,
];
